import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'vectronic-formly-time-input-box',
  imports: [CommonModule, MatIconModule, ReactiveFormsModule],
  templateUrl: './time-input-box.component.html',
  styleUrls: ['./time-input-box.component.scss'],
})
export class TimeInputBoxComponent {
  private readonly CHANGE_STEP_DURATION = 100;

  @Input()
  control: FormControl;

  /**
   * default 59
   */
  @Input()
  maxValue = 59;

  /**
   * default 0
   */
  @Input()
  minValue = 0;

  @Input()
  numberOfDigits: number = undefined;

  @Input()
  maxNumberOfDigits = 2;

  get inputWidthClass() {
    return `width-${this.maxNumberOfDigits}`;
  }

  #interval: NodeJS.Timeout = null;

  protected incrementValue() {
    this.changeValue(1);
  }

  protected decrementValue() {
    this.changeValue(-1);
  }

  protected preventNonNumericalInput(e: KeyboardEvent) {
    if (!e.key.match(/^\d+$/)) {
      e.preventDefault();
    }
  }

  protected startChanging(step: 1 | -1) {
    this.#interval = setInterval(() => {
      this.changeValue(step);
    }, this.CHANGE_STEP_DURATION);
  }

  protected stopChanging() {
    clearInterval(this.#interval);
  }

  protected onChange(val: string) {
    const newVal = this.getformattedValue(
      this.isValueCorrect(val) ? val : this.minValue.toString(),
    );
    this.control.setValue(newVal);
  }

  private changeValue(step: number) {
    if (this.control.disabled) {
      return;
    }
    const newValue: string = this.getformattedValue(
      (parseInt(this.control.getRawValue()) + step).toString(),
    );
    const newNumberValue = parseInt(newValue);
    if (newNumberValue >= this.minValue && newNumberValue <= this.maxValue) {
      this.control.setValue(newValue);
    }
  }

  private getformattedValue(value: string) {
    return this.numberOfDigits ? value.padStart(this.numberOfDigits, '0') : value;
  }

  private isValueCorrect(val: string): boolean {
    return val.match(/^\d+$/) && parseInt(val) >= this.minValue && parseInt(val) <= this.maxValue;
  }
}
